import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  id: '',
  url: '',
  name: '',
  size: 0,
  w: 0,
  h: 0,
  alt: '',
}

export const validateThumbnail = (active, { url, alt }) => ({
  url: active && url === '' && '이미지를 등록하세요.',
  alt: active && alt === '' && '이미지 설명을 입력하세요.',
})

export const getThumbnailAssetData = state => ({
  type: 'THUMBNAIL',
  data: {
    image: { ...state },
  },
})

const thumbnailSlice = createSlice({
  name: 'thumbnail',
  initialState,
  reducers: {
    reset: () => initialState,
    setAltText: (state, { payload: alt }) => {
      state.alt = alt
    },
    setThumbnail: (state, { payload: { image } }) => {
      const { id, url, w, h, alt, name, size } = image
      state.id = id
      state.url = url
      state.name = name
      state.size = size
      state.w = w
      state.h = h
      state.alt = alt
    },
    setThumbnailId: (state, { payload }) => {
      const image = payload.dspImageDtos.find(({ url }) => state.url === url)
      if (image) {
        state.id = image.id
      }
    },
    setImage: (state, { payload }) => {
      const { id, url, width, height, name, size } = payload
      state.id = id
      state.url = url
      state.name = name
      state.size = size
      state.w = width
      state.h = height
    },
    resetImage: state => {
      state.id = ''
      state.url = ''
      state.name = ''
      state.size = 0
      state.w = 0
      state.h = 0
    },
  },
})

export const {
  reset,
  setAltText,
  setImage,
  resetImage,
  setThumbnail,
  setThumbnailId,
} = thumbnailSlice.actions
export default thumbnailSlice.reducer
